/** @format */

import { requestProgresses } from '../constants';

const {
  AUTO_MANAGEMENT,
  SENDED_TO_WAREHOUSE,
  NO_AVAILABLE_OPTION,
  WAREHOUSE_CHECK,
  WAREHOUSE_CHECK_ENDED,
  BARGAINING_SALE,
  COMPLETED_SOLDED,
  COMPLETED_UNSOLDED,
  COMPLETED_UNAVAILABLE,
} = requestProgresses;

const progressIcons = {
  [AUTO_MANAGEMENT]: { name: 'sync', color: 'black', loading: false },
  [SENDED_TO_WAREHOUSE]: { name: 'warehouse', color: 'black', loading: false },
  [WAREHOUSE_CHECK_ENDED]: { name: 'check', color: 'green', loading: false },
  [BARGAINING_SALE]: { name: 'dollar sign', color: 'green', loading: false },
  [NO_AVAILABLE_OPTION]: { name: 'cancel', color: 'red', loading: false },
  [WAREHOUSE_CHECK]: { name: 'circle notched', color: 'orange', loading: true },
  [COMPLETED_SOLDED]: { name: 'check', color: 'green', loading: false },
  [COMPLETED_UNSOLDED]: { name: 'cancel', color: 'orange', loading: false },
  [COMPLETED_UNAVAILABLE]: { name: 'ban', color: 'red', loading: false },
};

const renderProgressIcon = progress => {
  if (progress) {
    return (
      progressIcons[progress.toLowerCase()] || progressIcons[NO_AVAILABLE_OPTION]
    );
  }
  return null
};

export default renderProgressIcon;
